import { Component } from '@angular/core';

@Component({
    selector: 'app-end-user-license-agreement',
    templateUrl: './app.end-user-license-agreement.component.html',
    standalone: false
})
export class AppEndUserLicenseAgreementComponent {

}
